import styled from '@emotion/styled';
import {AppBar, IconButton, Toolbar, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { router } from '../../Routes/routhPaths';
import { config } from '../../Constants';

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[3]
}));

export const HeaderView = (props) => {
  let navigate = useNavigate();
  let theme = useTheme();
  const { onSidebarOpen, ...other } = props;

  const logout = () =>{
    sessionStorage.removeItem("userLogged");
    navigate(router.login)
  }

  return (
    <>
      <DashboardNavbarRoot
        sx={{
          left: {
            lg: 280,
          },
          width: {
            lg: 'calc(100% - 280px)',
          }
        }}
        {...other}>
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64,
            px: 2,
            justifyContent: 'space-between',
            background: '#fff',
            borderBottom: '1px solid '+theme.palette.primary.main
          }}
        >
          <IconButton
            onClick={onSidebarOpen}
            sx={{
              position: 'none',
              display: {
                xs: 'inline-flex',
                lg: 'none'
              },
              color: theme.palette.primary.main,
            }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
          <img src={config.url.file_url+props.org?.logo} width= '150' alt="" onClick={()=>navigate(router.main)}/>
          <IconButton sx={{color: theme.palette.primary.main}} onClick={()=>logout()}>
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </DashboardNavbarRoot>
    </>
  );
};
